import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatAutocompleteSelectedEvent, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { v4 as uuidv4 } from 'uuid';
import { ApiService } from '../shared/api.service';
import { timeout } from 'rxjs/operators';

@Component({
  selector: 'app-water-source-dropdown',
  templateUrl: './water-source-dropdown.component.html',
  styleUrls: ['./water-source-dropdown.component.css']
})
export class WaterSourceDropdownComponent implements OnInit, AfterViewInit {

  @ViewChild('waterSourceTrigger') autocomplete: MatAutocompleteTrigger;
  @ViewChild('inputField') inputField: ElementRef;

  @Input() apiUid: string;
  @Input() selectedItem;
  @Input() idToken: string;
  @Input() labelNeeded: boolean;
  @Input() focusNeeded: boolean;
  @Input() widthNeeded: boolean;
  @Input() clearNeeded: boolean;
  @Input() maxWidthNeeded: boolean;
  @Input() userSavedWaterSources: Array<any>;

  @Output() getUserData = new EventEmitter<boolean>();
  @Output() setNewTestWaterSourceData = new EventEmitter<any>();
  lastTypedSourceValue: string;
  filteredUserSavedWaterSources: any[];
  showWaterSourceClear = false;
  private newTest = false;


  constructor(private apiService: ApiService) {
  }

  ngOnInit(): void {
    this.lastTypedSourceValue = this.selectedItem.location?.waterSource || '';
    this.filterUserWaterSources(this.lastTypedSourceValue);
    if (this.focusNeeded) {

      this.autocomplete?.openPanel();
    }

    // New test if it has no calculation result
    this.newTest = this.selectedItem.calculationResult.testId === undefined;

  }

  ngAfterViewInit() {
    if (this.focusNeeded) {
      console.log('hi');
      this.inputField.nativeElement.focus();
      console.log(this.autocomplete);
      setTimeout(() => this.autocomplete?.openPanel(), 50);

      console.log(this.autocomplete);
      console.log(this.autocomplete.panelOpen);

    }
  }

  async handleWaterSourceChange($event: MatAutocompleteSelectedEvent, testId: string, testPlaceId: string) {
    console.log(testPlaceId, 'testPlaceId');
    // const target = $event.target as HTMLInputElement; // Specifying $event.target type to avoid weird typing error
    const testApiData = {
      'location.waterSource': $event.option.value.name
    };
    const userApiData = {
      waterSources: {
        name: $event.option.value.name,
        place_id: $event.option.value.place_id || testPlaceId,
        source_id: $event.option.value.source_id || uuidv4()
      },
      uid: this.apiUid
    };
    if (!this.newTest) {
      await this.apiService.updateTestData(testApiData, testId, this.apiUid, this.idToken);
      if (this.userSavedWaterSources.filter(source => source === $event.option.value).length === 0) {
        this.saveWaterSource(userApiData);
      }
      this.lastTypedSourceValue = $event.option.value.name;
      this.getUserData.emit(true);
    } else {
      this.setNewTestWaterSourceData.emit(userApiData.waterSources);
    }

    // this.selectWaterSource();
  }

  async handleWaterSourceChangeManual($event: any, testId: any, testPlaceId: string) {
    console.log(testPlaceId, 'testPlaceId');
    const target = $event.target as HTMLInputElement; // Specifying $event.target type to avoid weird typing error
    console.log(this.lastTypedSourceValue);
    const testApiData = {
      'location.waterSource': target.value
    };
    const userApiData = {
      waterSources: {
        name: target.value,
        place_id: testPlaceId,
        source_id: uuidv4()
      },
      uid: this.apiUid
    };
    if (!this.newTest) {
      await this.apiService.updateTestData(testApiData, testId, this.apiUid, this.idToken);
      this.saveWaterSource(userApiData);
      this.autocomplete.closePanel();
      this.getUserData.emit(true);
    } else {
      this.setNewTestWaterSourceData.emit(userApiData.waterSources);
    }
  }

  async saveWaterSource(userApiData: { waterSources: { name: string, place_id: string, source_id: string }, uid: string }) {
    await this.apiService.saveWaterSource(userApiData, this.apiUid, this.idToken);
  }

  displayFnWaterSource(value?): string {
    if (value) {
      return value.name ? value.name : this.selectedItem.location.waterSource;
    }
    return '';
  }

  filterUserWaterSources(value?) {
    const filterValue = value ? typeof value === 'string' ? value : '' : this.lastTypedSourceValue ? this.lastTypedSourceValue : '';
    console.log(filterValue, this.lastTypedSourceValue, 'values');
    this.lastTypedSourceValue = filterValue;
    this.filteredUserSavedWaterSources = this.userSavedWaterSources.filter(waterSource => {
      return waterSource.name && waterSource.name.toLowerCase().includes(filterValue.toLowerCase())
        && waterSource.place_id === this.selectedItem.location?.place_id;
    }).slice(0, 5);
  }

  async deleteWaterSource($event: MouseEvent) {
    const target = $event.currentTarget as HTMLButtonElement;
    console.log(target.value);
    if (target.value !== undefined) {
      const selectedWaterSource = this.userSavedWaterSources.filter(savedWaterSource => {
        return savedWaterSource.source_id === target.value;
      })[0];
      const data = {
        waterSources: selectedWaterSource
      };
      await this.apiService.deleteWaterSource(data, this.apiUid, this.idToken);
      this.getUserData.emit(true);

      this.filterUserWaterSources();
    }

  }


  clearWaterSourceInput() {
    this.lastTypedSourceValue = '';
    document.getElementById('waterSourceInput').focus();
  }
}

